import { useState } from "react";
import "./App.css";
import About from "./Components/About/About";
import CTA from "./Components/CallToAction/CTA";
import Footer from "./Components/Footer/Footer";
import Form from "./Components/Form/Form";
import Hero from "./Components/Hero/Hero";
import Navbar from "./Components/Navbar/Navbar";
import Work from "./Components/OurWork/Work";
import Traditional from "./Components/Traditional/Traditional";
import Toast from "./Components/Toast/Toast";
import SnapWidgetPrivacyPolicy from "./Components/PrivacyPolicy/SnapWidgetPrivacyPolicy";
import SnapWidgetTermsOfService from "./Components/PrivacyPolicy/SnapWidgetTermsOfService";
import SnapWidgetCsaeStandards from "./Components/PrivacyPolicy/SnapWidgetCsaeStandards";
import SnapWidgetAccountDeletion from "./Components/AccountDeletion/SnapWidgetAccountDeletion";
import AudioSplitPrivacyPolicy from "./Components/PrivacyPolicy/AudioSplitPrivacyPolicy";
import AudioSplitTermsOfService from "./Components/PrivacyPolicy/AudioSplitTermsOfService";
import AudioSplitCsaeStandards from "./Components/PrivacyPolicy/AudioSplitCsaeStandards";
import AudioSplitDeletionRequest from "./Components/AccountDeletion/AudioSplitDeletionRequest";
import PrivacyScreenGuardPrivacyPolicy from "./Components/PrivacyPolicy/PrivacyScreenGuardPrivacyPolicy";
import PrivacyScreenGuardTermsAndConditions from "./Components/PrivacyPolicy/PrivacyScreenGuardTermsAndConditions";
import cover from "./Components/OurWork/assets/work1/app-cover.png";
import logo from "./Components/OurWork/assets/work1/app-icon.png";
import logo2 from "./Components/OurWork/assets/work2/privacyLogo.jpg";
import cover2 from "./Components/OurWork/assets/work2/cover1.jpg";
import logo3 from "./Components/OurWork/assets/work3/icon3.png";
import cover3 from "./Components/OurWork/assets/work3/cover3.png";
function App() {
  const [isForm, setIsForm] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [type, setType] = useState();

  if (window.location.pathname === "/apps/snapwidget/privacy-policy") {
    return <SnapWidgetPrivacyPolicy />;
  }

  if (window.location.pathname === "/apps/snapwidget/terms-of-service") {
    return <SnapWidgetTermsOfService />;
  }

  if (window.location.pathname === "/apps/snapwidget/csae-standards") {
    return <SnapWidgetCsaeStandards />;
  }

  if (window.location.pathname === "/apps/snapwidget/delete-account") {
    return <SnapWidgetAccountDeletion />;
  }

  if (window.location.pathname === "/apps/audiosplit/privacy-policy") {
    return <AudioSplitPrivacyPolicy />;
  }

  if (window.location.pathname === "/apps/audiosplit/terms-of-service") {
    return <AudioSplitTermsOfService />;
  }

  if (window.location.pathname === "/apps/audiosplit/csae-standards") {
    return <AudioSplitCsaeStandards />;
  }

  if (window.location.pathname === "/apps/audiosplit/delete-account") {
    return <AudioSplitDeletionRequest />;
  }

  if (window.location.pathname === "/apps/privacy-screen-guard/privacy-policy") {
    return <PrivacyScreenGuardPrivacyPolicy />;
  }

  if (
    window.location.pathname === "/apps/privacy-screen-guard/terms-and-conditions" ||
    window.location.pathname === "/apps/privacy-screen-guard/terms-of-service"
  ) {
    return <PrivacyScreenGuardTermsAndConditions />;
  }

  const workData = [
    // {
    //   coverImage: cover3,
    //   iconImage: logo3,
    //   name: "The Ideas",
    //   appLink: "https://reddit-scraper-fe.vercel.app/",
    //   description: "Get real problems to solve for your next startup",
    // },

    {
      coverImage: cover2,
      iconImage: logo2,
      name: "Privacy Screen Guard",
      appLink: "https://play.google.com/store/apps/details?id=com.filter.guard.screen.privacy",
      description:
        "Privacy Screen Guard is a powerful privacy screen app designed to protect your screen from prying eyes in public places.",
    },

    {
      coverImage: cover,
      iconImage: logo,
      // "https://play-lh.googleusercontent.com/v30dJO88np00fquvBL0mts22OHd_tBu6DmRl1c6VLvk0w9QEMQZOkrPadQc0Gh9MSJ2R=w416-h235-rw",

      // iconImage:
      //   "https://play-lh.googleusercontent.com/Y7T6KvfC_nVuliJU6vWcLVbgyH7NDBs1PEfc8Imi6NzzFeK-4Puue86rBrl-31UJJXI=w240-h480-rw",
      name: "SpotYourIdea",
      appLink:
        "https://spotyouridea.com",
      description:
        "Discover real user problems and validate startup ideas from high-signal conversations across the web.",
    },
    {
      coverImage: cover3,
      iconImage: logo3,
      // "https://play-lh.googleusercontent.com/v30dJO88np00fquvBL0mts22OHd_tBu6DmRl1c6VLvk0w9QEMQZOkrPadQc0Gh9MSJ2R=w416-h235-rw",

      // iconImage:
      //   "https://play-lh.googleusercontent.com/Y7T6KvfC_nVuliJU6vWcLVbgyH7NDBs1PEfc8Imi6NzzFeK-4Puue86rBrl-31UJJXI=w240-h480-rw",
      name: "MyTrustMetrics",
      appLink:
        "https://mytrustmetrics.com",
      description:
        "Deterministic analytics revealing growth patterns, content strategy, and performance insights",
    }
  ];

  function handleIsForm(e) {
    setIsForm(e);
  }

  function handleType(e) {
    setType(e);
  }

  function handleIsToast(e) {
    setShowToast(e);
  }

  return (
    <div className="App">
      <Navbar isForm={handleIsForm} />
      <Hero isForm={handleIsForm} />
      <Traditional />
      <About />
      <div className="black">
        <Work data={workData} />
        <CTA isForm={handleIsForm} />
        <Footer />
      </div>
      {isForm && (
        <Form type={handleType} isToast={handleIsToast} isForm={handleIsForm} />
      )}
      {showToast && (
        <Toast
          type={type}
          message={`${type === "success"
            ? "Acknowledged! We'll get back to you shortly."
            : "Sorry, couldn't process."
            }`}
          duration={3000}
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
}

export default App;
